import { CustomFormQuestion } from 'components/tools/CustomForm/types'

export const dynamicTextValidators = (text: string, question: CustomFormQuestion): string => {
  let error = ''
  if (question?.validation && question?.validation.max) {
    if (text.length > question?.validation?.max) {
      error = 'Máximo caractéres alcançado'
    }
  }
  return error
}

type ValidateTextOnCustomFormParams = {
  text: string
  question: CustomFormQuestion
}

export default function validateTextOnCustomForm({ text, question }: ValidateTextOnCustomFormParams) {
  let error = ''
  if (question.is_required && !text) {
    error = 'Este campo é obrigatório'
  }
  if (text) {
    const errorMessage = dynamicTextValidators(text, question)
    if (errorMessage !== '') {
      error = errorMessage
    }
  }
  return error
}
